define([
	'internal_util/Logger',
	'internal_util/Util',
	'amdi18n-loader?!model/nls/Terminal_strings'
], function (
	Logger,
	Util,
	Strings
) {
	'use strict';

	/**
	 * Terminal class
	 * 
	 * @param id
	 * @param name
	 * @param contextHandle
	 * @returns {Terminal}
	 */
	return function (id, name, contextHandle) {
		var _id, // the terminal identifier
			_name, // the terminal name
			_contextHandle, // the terminal's context handle
			_cards = {}; // the registered cards

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			throw new Error('invalid terminal id: ' + id);
		}

		if (Util.isValidString(name)) {
			_name = name;
		} else {
			throw new Error('invalid terminal name: ' + name);
		}

		if (Util.isValidString(contextHandle)) {
			_contextHandle = contextHandle;
		} else {
			throw new Error('invalid terminal context handle: ' + contextHandle);
		}


		// private methods

		function log(method, message, data) {
			Logger.log('Terminal', method, message, data);
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.name = function () {
			return _name;
		};

		this.contextHandle = function () {
			return _contextHandle;
		};

		this.getCard = function (cardId) {
			if (_cards.hasOwnProperty(cardId)) {
				return _cards[cardId];
			}

			log('getCard', Strings.card_not_found, cardId);

			return null;
		};

		this.addCard = function (card) {
			var _name = 'addCard';

			if (_cards.hasOwnProperty(card.id())) {
				log(_name, Strings.replaced_card, {old : _cards[card.id()], 'new' : card});
			} else {
				log(_name, Strings.added_card, card);
			}

			_cards[card.id()] = card;
		};

		this.removeCard = function (cardId) {
			var _name = 'removeCard',
				card = null;

			if (_cards.hasOwnProperty(cardId)) {
				card = _cards[cardId];

				delete _cards[cardId];

				log(_name, Strings.removed_card, cardId);
			} else {
				log(_name, Strings.card_not_found, cardId);
			}

			return card;
		};

		this.toObject = function () {
			return {
				id : _id,
				name : _name,
				contextHandle : _contextHandle,
				cards : Util.serialize(_cards)
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Terminal.js
// module id = 156
// module chunks = 3